import { useId } from 'react'
import { observer } from 'mobx-react-lite'
import { RenameDocumentDialog } from './index'
import { type RenameDocumentDialogViewModel } from './RenameDocumentDialogViewModel'
import { TextFieldContainer } from '@/components/inputs/TextFieldContainer'
import { FormContainer } from '@/components/FormContainer'

export interface RenameDocumentDialogContainerProps {
  vm: RenameDocumentDialogViewModel
}

/**
 * Container for the RenameDocumentDialog that wires up the view model.
 */
export const RenameDocumentDialogContainer = observer(
  function RenameDocumentDialogContainer({
    vm,
  }: RenameDocumentDialogContainerProps) {
    const formId = useId()
    return (
      <RenameDocumentDialog
        isOpen={vm.modal.showing}
        onClose={vm.cancel}
        isDismissable={!vm.rename.pending}
        isRenamePending={vm.rename.pending}
        submitButtonForm={formId}
      >
        <FormContainer
          id={formId}
          onSubmit={vm.rename}
          disabled={vm.rename.pending}
        >
          <TextFieldContainer
            model={vm}
            field="newName"
            aria-label="New name"
            placeholder={vm.document?.title}
          />
        </FormContainer>
      </RenameDocumentDialog>
    )
  },
)
